import React, { Component, createRef } from "react";

import { withTranslation } from "react-i18next";
import QRCode from "react-qr-code";

class QrcodeGenerator extends Component {
  constructor(props) {
    super(props);
    console.log(props);
    this.state = { ...props };
  }

  render() {
    document.title = "data-entry flow";
    return <QRCode value={this.state?.value?.row?.id} size="70" />;
  }
}
export default withTranslation()(QrcodeGenerator);
